import React from 'react';
import { PrimaryButton } from '../../../PrimaryButton';
import { GreyButton } from '../../../GreyButton';
import { Modal } from '../../../Modal';
import { CurrentThermostat } from '../../../../store/thermostat/types';
import { BackButton } from '../../../BackButton';
import './ThermostatInfo.css';

export interface Props {
  currentThermostat: CurrentThermostat;
  currentBuilding: string;
  onClose(): void;
  mainButtonOnClick(): void;
}

export const ThermostatInfo = (props: Props) => {
  const { currentBuilding, currentThermostat, onClose, mainButtonOnClick } = props;
  const {
    serial_number: serialNumber,
    display_name: displayName,
    connection_state: connectionState,
  } = currentThermostat;

  return (
    <Modal>
      <div className="thermostat-info">
        <div className="thermostat-info__title">
          <div className="thermostat-info-title__back-button-div">
            <BackButton onClick={onClose} />
          </div>
          <div className="thermostat-info-title__div">
            <div className="thermostat-info__title-text">Thermostat info</div>
          </div>
          <div className="thermostat-info__close-button-wrapper">
            <input id="close-button-mobile" className="thermostat-info__close-button" type="button" onClick={onClose} />
          </div>
        </div>
        <div className="thermostat-info__page">
          <div className="thermostat-info-page__thermostat-zone-input">
            <div className="thermostat-info-page__zone-text-input">
              <label htmlFor="zone-input">
                Zone:
                <input
                  id="zone-input"
                  className="thermostat-info__zone-input"
                  type="text"
                  value={displayName}
                  readOnly={true}
                  disabled={true}
                />
              </label>
            </div>
            <div className="thermostat-info-page__zone-text-input">
              <label htmlFor="site-input">
                Site:
                <input
                  id="site-input"
                  className="thermostat-info__site-input"
                  type="text"
                  value={currentBuilding}
                  readOnly={true}
                  disabled={true}
                />
              </label>
            </div>
            <div className="thermostat-info-page__zone-text-input">
              <label htmlFor="serialno-input">
                Serial Number:
                <input
                  id="serialno-input"
                  className="thermostat-info__serial-no-input"
                  type="text"
                  value={serialNumber}
                  readOnly={true}
                  disabled={true}
                />
              </label>
            </div>
            <div className="thermostat-info-page__zone-text-input">
              <label htmlFor="status-input">
                Status:
                <input
                  id="status-input"
                  className="thermostat-info__status-input"
                  type="text"
                  value={connectionState}
                  readOnly={true}
                  disabled={true}
                />
              </label>
            </div>
          </div>
          <div className="themostat-info-page__buttons-wrapper">
            <div className="thermostat-info-page__button thermostat-info__back-button-wrapper">
              <PrimaryButton icon="back-icon" label="Back" onClick={onClose} fullWidth={true} />
            </div>
            <div id="close-info-mobile" className="thermostat-info-page__button thermostat-info-page__update-pin">
              <GreyButton
                label={connectionState === 'reset' ? 'Reauthenticate' : 'Settings'}
                onClick={mainButtonOnClick}
                fullWidth={true}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
